import { useState } from 'react';
import { useAuthStore } from '@/store/authStore';
import { UserRole } from '@/types';

export function useUsers() {
  const { 
    users, 
    isLoading, 
    error,
    fetchUsers,
    addUser,
    updateUserPhone,
    updateUserPassword,
    deleteUser
  } = useAuthStore();
  const [showAddDialog, setShowAddDialog] = useState(false);

  const handleAddUser = async (userData: { 
    username: string; 
    phoneNumber: string;
    password: string;
    role: UserRole;
  }) => {
    try {
      await addUser(userData);
      setShowAddDialog(false);
    } catch (error) {
      console.error('Failed to add user:', error);
      throw error;
    }
  };

  const handleUpdatePhone = async (userId: string, phoneNumber: string) => {
    try {
      await updateUserPhone(userId, phoneNumber);
    } catch (error) {
      console.error('Failed to update phone:', error);
      throw error;
    }
  };

  const handleUpdatePassword = async (userId: string, password: string) => {
    try {
      await updateUserPassword(userId, password);
    } catch (error) {
      console.error('Failed to update password:', error);
      throw error;
    }
  };

  const handleDeleteUser = async (userId: string) => {
    try {
      await deleteUser(userId);
    } catch (error) {
      console.error('Failed to delete user:', error);
      throw error;
    }
  };

  return {
    users,
    isLoading,
    error,
    showAddDialog,
    setShowAddDialog,
    handleAddUser,
    handleUpdatePhone,
    handleUpdatePassword,
    handleDeleteUser,
    fetchUsers
  };
}